export default class ThemeToggle {
	constructor(themeToggleEl) {
		 this.toggleSwitch = themeToggleEl;
		 this.init();
	}

	init() {
		 this.toggleSwitch.addEventListener('change', () => this.switchTheme());
		 this.toggleSwitch.addEventListener('keydown', (e) => this.handleKeyDown(e));

		 this.restoreTheme();
	}

	handleKeyDown(e) {
		 if (e.key === 'Enter' || e.keyCode === 13) {
			  e.preventDefault();
			  this.toggleSwitch.click();
		 }
	}

	switchTheme() {
		 const isLightMode = this.toggleSwitch.checked;
		 this.updateTheme(isLightMode);

		 // Save the selected theme to localStorage
		 localStorage.setItem('theme', isLightMode ? 'light' : 'dark');
	}

	restoreTheme() {
		 const savedTheme = localStorage.getItem('theme');
		 const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

		 const isLightMode = savedTheme === 'light' || (!savedTheme && !prefersDark);
		 this.updateTheme(isLightMode);
	}

	updateTheme(isLightMode) {
		this.toggleSwitch.checked = isLightMode;
		this.toggleSwitch.setAttribute('aria-label', isLightMode ? 'Light mode' : 'Dark mode');
		this.toggleSwitch.setAttribute('checked', isLightMode ? 'true' : 'false');

		// Update HTML attribute for theme
		document.documentElement.setAttribute('data-theme', isLightMode ? 'light' : 'dark');
  }
}
